enum QuestionAnswerFeedbackType {
    Correct = 'Correct',
    Incorrect = 'Incorrect',
}

export default QuestionAnswerFeedbackType;
